import clsx from 'clsx';
import React, { useEffect } from 'react';
import { useStopwatch } from 'react-timer-hook';

import { CallState } from '../VirtualDirectoryContactRow';
import styles from './styles';
import WhitePhoneIcon from '../../assets/icons/phone-white.png';
import StopIcon from '../../assets/icons/stop.svg';
import MicrophoneIcon from '../../assets/icons/microphone.svg';
import { pad } from './helper';

interface CallScreenProps {
  onEndCall: () => void;
  onDigitPress: (digit: string) => void;
  name: string;
  callState: CallState;
}

const CallScreen: React.FC<CallScreenProps> = ({
  name,
  onEndCall,
  onDigitPress,
  callState,
}) => {
  const { minutes, seconds } = useStopwatch({ autoStart: true });

  useEffect(() => {
    document.body.classList.add('preventScroll');

    return () => {
      document.body.classList.remove('preventScroll');
    };
  }, []);

  const isRecordingDisabled = () => {
    return callState !== 'INITIATED' && callState !== 'CONNECTED';
  };

  const isStopRecordingDisabled = () => {
    return callState !== 'RECORDING';
  };

  return (
    <div className={styles.callInProcessLayout}>
      <div className={styles.callInProcessBackground}></div>
      <div className={clsx([styles.displayFlexWrapper, styles.callScreenContainer])}>
        <div className={styles.timeWrapper}>
          <div className={styles.residentName}><b>{name}</b></div>
          <div style={callState === 'ON_HOLD' ? {display: 'none'} : {}}>
            {minutes}:{pad(seconds)}
          </div>
          <div style={callState === 'ON_HOLD' ? {} : {display: 'none'}}>
            Calling...
          </div>
        </div>
        <div className={clsx([styles.displayFlexWrapper, styles.row])}>
          <div style={isRecordingDisabled() ? { opacity: 0.5 } : {}}>
            <button
              disabled={isRecordingDisabled()}
              className={styles.callscreenButton}
              onClick={() => onDigitPress('1')}
            >
              <img src={MicrophoneIcon} alt="Record" style={{ width: 25 }} />
            </button>
            <div>Record</div>
          </div>
          <div style={isStopRecordingDisabled() ? { opacity: 0.5 } : {}}>
            <button
              disabled={isStopRecordingDisabled()}
              className={styles.callscreenButton}
              onClick={() => onDigitPress('*')}
            >
              <img src={StopIcon} alt="Stop Record" style={{ width: 20 }} />
            </button>
            <div>Stop Record</div>
          </div>
        </div>
        <div className={styles.row}>
          <button
            className={clsx([styles.callscreenButton, styles.endCall])}
            onClick={() => onEndCall()}
          >
            <img src={WhitePhoneIcon} alt="" style={{ width: 35 }} />
          </button>
        </div>
      </div>
    </div>
  );
};

export default CallScreen;
